module.exports = __webpack_public_path__ + "static/img/security-secure.69b615f.png";


//////////////////
// WEBPACK FOOTER
// ./static/appicons/security-secure.png
// module id = 1146
// module chunks = 0